import React, { Component } from "react";
import { connect } from "react-redux";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import Button from "../../../button-classic/button-classic";
import { MdSearch, MdClose } from "react-icons/md";
import ACTIONS from "../../../../common/action_constant";
import AddSupplierItemMaster from "./add-supplier-item-master";
import { debounce } from "../../../../utils/index";
import LoaderComponent from "../../../../common/components/loader/loader";

class SupplierItemMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      isOpen: false,
      editData: null,
      listData: [],
      search: "",
    };
    this.debouncedGetSupplierItemMasterData = debounce(
      this.getSupplierItemMasterData,
      400
    );
  }

  componentDidMount() {
    this.getSupplierItemMasterData();
  }

  getSupplierItemMasterData = () => {
    const { dispatch, companyId } = this.props;
    const { offset, limit, search } = this.state;
    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }

    dispatch({
      type: ACTIONS.PLANTS.GET_SUPPLIER_ITEM_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ listData: res || [] });
      },
    });
  };

  onSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ search: value, offset: 0 });
    this.debouncedGetSupplierItemMasterData();
  };

  clearSearch = () => {
    this.setState({ search: "", offset: 0 }, this.getSupplierItemMasterData);
  };

  toggleAdd = () => {
    this.setState({ isOpen: !this.state.isOpen, editData: null });
  };

  editSupplierItemMaster = (item) => {
    this.setState({ isOpen: true, editData: item });
  };

  deleteSupplierItemMaster = (item) => {
    const { dispatch, companyId } = this.props;

    dispatch({
      type: ACTIONS.PLANTS.DELETE_SUPPLIER_ITEM_MASTER,
      data: {
        company_id: companyId,
        master_id: item.master_id,
      },
      onSuccess: () => {
        this.getSupplierItemMasterData();
      },
    });
  };

  next = () => {
    this.setState(
      (prevState) => ({ offset: prevState.offset + prevState.limit }),
      this.getSupplierItemMasterData
    );
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({ offset: prevState.offset - prevState.limit }),
        this.getSupplierItemMasterData
      );
    }
  };

  render() {
    const { listData, search } = this.state;
    const { companyId, dispatch, loader } = this.props;

    return (
      <div className="location-network">
        {!!loader?.loaderT1 && <LoaderComponent />}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <div
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <MdSearch
              size={18}
              style={{
                position: "absolute",
                left: "10px",
                color: "#8a8a8a",
                pointerEvents: "none",
              }}
            />
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={this.onSearchChange}
              style={{
                padding: "8px 30px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                minWidth: "220px",
              }}
            />
            {search !== "" && (
              <MdClose
                size={16}
                onClick={this.clearSearch}
                style={{
                  position: "absolute",
                  right: "10px",
                  color: "#8a8a8a",
                  cursor: "pointer",
                }}
              />
            )}
          </div>
          <Button value="+ Add Supplier Item" click={this.toggleAdd} />
        </div>

        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Item Numbers</th>
              <th>Process Points</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {listData.length > 0 ? (
              listData.map((item, index) => (
                <tr key={item.master_id || index}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      <span>{item.item_name}</span>
                      {item.is_manual_add && (
                        <span
                          className="free-text-badge"
                          title="Added through free text"
                          style={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            padding: "1px 8px",
                            fontSize: "10px",
                            fontWeight: 600,
                            lineHeight: "16px",
                            borderRadius: "10px",
                            backgroundColor: "#e8f0fe",
                            color: "#1a56db",
                          }}
                        >
                          Free Text
                        </span>
                      )}
                    </div>
                  </td>
                  <td>{(item.item_numbers || []).join(", ")}</td>
                  <td>{(item.process_points_details || []).length} points</td>
                  <td>
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Edit})` }}
                      onClick={() => this.editSupplierItemMaster(item)}
                    />
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Delete})` }}
                      onClick={() => this.deleteSupplierItemMaster(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>

        {this.state.isOpen && (
          <AddSupplierItemMaster
            toggleAdd={this.toggleAdd}
            editData={this.state.editData}
            companyId={companyId}
            dispatch={dispatch}
            refreshData={this.getSupplierItemMasterData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loader: state.loader,
});

export default connect(mapStateToProps)(SupplierItemMaster);
